import { render, staticRenderFns } from "./Freelance.vue?vue&type=template&id=2d8640f1"
import script from "./Freelance.vue?vue&type=script&lang=js"
export * from "./Freelance.vue?vue&type=script&lang=js"
import style0 from "./Freelance.vue?vue&type=style&index=0&id=2d8640f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports